
import Vue from 'vue' // 引入vue

const EventBus = new Vue() // 创建实例

export default EventBus // 导出


// WEBPACK FOOTER //
// ./src/utils/eventBus.js